module.exports = __webpack_public_path__ + "img/temp-postIt.7a1b4200.svg";